import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { LoggerService } from 'src/app/services/logger/logger.service';
import { BASE_CONFIG } from 'src/app/util/base-settings';
import { COMPONENT_NAME } from 'src/app/util/constants';

@Component({
  selector: 'a24-draggable-slider',
  templateUrl: './draggable-slider.component.html',
  styleUrls: ['./draggable-slider.component.scss'],
})
export class DraggableSliderComponent implements OnInit {

  tabsBox: any;
  allTabs: any;
  arrowIcons: any;
  isDragging: boolean = false;
  previousScreenX: any = null;

  @Input() sliderList = [];
  @Input() showBy : string ;
  @Input() trackBy : string ;
  @Input() isNeedNavIcon: boolean = true;
  @Output() selectedTitle = new EventEmitter();
  @ViewChild('dragSliderRef') dragSliderRef;
  constructor(
    private logger: LoggerService
  ) { }

  ngOnInit() {
  }

  ngAfterViewInit()
  {
    try {
      if (BASE_CONFIG.IS_DEBUG) console.log('ngAfterViewInit');

      let dragSliderRef=this.dragSliderRef.nativeElement;
      const that = this;
      that.tabsBox = dragSliderRef.querySelector(".tabs-box");
      that.allTabs = that.tabsBox.querySelectorAll(".tab");
      that.arrowIcons = dragSliderRef.querySelectorAll(".icon i");
  
      that.tabsBox.addEventListener("touchstart", () => that.isDragging = true);
      that.tabsBox.addEventListener("touchmove", that.dragging.bind(this));
      document.addEventListener("touchend", that.dragStop.bind(this));
    } catch (error) {
      let logRequest = this.logger.buildRequest(
        COMPONENT_NAME.DRAGGABLE_SLIDER_COMPONENT,
        'error in ngAfterViewInit',
        error.toString(),
        'ngAfterViewInit'
      );
      this.logger.log(logRequest);
    }
  }

  clickHandler(pEvent)
  {
    try {
      if (BASE_CONFIG.IS_DEBUG) console.log('clickHandler');
      for(let item of this.sliderList) {
        item.isSelected = item[this.trackBy] == pEvent[this.trackBy] ? true : false ;
        item[this.trackBy] == pEvent[this.trackBy] ? this.selectedTitle.emit(item) : null;
      }    
    } catch (error) {
      let logRequest = this.logger.buildRequest(
        COMPONENT_NAME.DRAGGABLE_SLIDER_COMPONENT,
        'error in clickHandler',
        error.toString(),
        'clickHandler'
      );
      this.logger.log(logRequest);
    }
  }

  onIconClick(pEvent)
  {  
    try {
      if (BASE_CONFIG.IS_DEBUG) console.log('onIconClick');
      let scrollWidth = this.tabsBox.scrollLeft += pEvent.target.id === "left" ? -340 : 340;
      this.handleIcons(scrollWidth);
    } catch (error) {
      let logRequest = this.logger.buildRequest(
        COMPONENT_NAME.DRAGGABLE_SLIDER_COMPONENT,
        'error in onIconClick',
        error.toString(),
        'onIconClick'
      );
      this.logger.log(logRequest);
    }
  }

  dragStop()
  {
    try {
      if (BASE_CONFIG.IS_DEBUG) console.log('dragStop');
      this.previousScreenX = null;
      this.isDragging = false;
      this.tabsBox.classList.remove("dragging");
    } catch (error) {
      let logRequest = this.logger.buildRequest(
        COMPONENT_NAME.DRAGGABLE_SLIDER_COMPONENT,
        'error in dragStop',
        error.toString(),
        'dragStop'
      );
      this.logger.log(logRequest);
    }
  }

  dragging(e)
  {
    try {
      if (BASE_CONFIG.IS_DEBUG) console.log('dragging');
      if (e.touches) {
        const currentScreenX = e.touches[0].screenX;
        if (this.previousScreenX) {
          let movementX = currentScreenX - this.previousScreenX;
          if(!this.isDragging) return;
          this.tabsBox.classList.add("dragging");
          this.tabsBox.scrollLeft -= movementX;
          if (this.isNeedNavIcon) {
            this.handleIcons(this.tabsBox.scrollLeft);
          }
        }
        this.previousScreenX = currentScreenX;
      }
      else if (e.movementX) {
        if(!this.isDragging) return;
        this.tabsBox.classList.add("dragging");
        this.tabsBox.scrollLeft -= e.movementX;
        if (this.isNeedNavIcon) {
          this.handleIcons(this.tabsBox.scrollLeft);
        }
      }
    } catch (error) {
      let logRequest = this.logger.buildRequest(
        COMPONENT_NAME.DRAGGABLE_SLIDER_COMPONENT,
        'error in dragging',
        error.toString(),
        'dragging'
      );
      this.logger.log(logRequest);
    }
  }

  dragStart()
  {
    try {
      if (BASE_CONFIG.IS_DEBUG) console.log('dragStart');
      this.isDragging = true;
    } catch (error) {
      let logRequest = this.logger.buildRequest(
        COMPONENT_NAME.DRAGGABLE_SLIDER_COMPONENT,
        'error in dragStart',
        error.toString(),
        'dragStart'
      );
      this.logger.log(logRequest);
    }
  }

  handleIcons(scrollVal)
  {
    try {
      if (BASE_CONFIG.IS_DEBUG) console.log('handleIcons');
      let maxScrollableWidth = this.tabsBox.scrollWidth - this.tabsBox.clientWidth;
      this.arrowIcons[0].parentElement.style.display = scrollVal <= 0 ? "none" : "flex";
      this.arrowIcons[1].parentElement.style.display = maxScrollableWidth - scrollVal <= 1 ? "none" : "flex";
    } catch (error) {
      let logRequest = this.logger.buildRequest(
        COMPONENT_NAME.DRAGGABLE_SLIDER_COMPONENT,
        'error in handleIcons',
        error.toString(),
        'handleIcons'
      );
      this.logger.log(logRequest);
    }
  }

  trackItems(pIndex: number, propOptions: any)
  {
    return pIndex;
  }

}
